import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import blosterService from "../services/bolster.service";
import { setMessage } from "./message";
export const fetchBlosterList = createAsyncThunk(
    'bloster/fetchBlosterList',
    async ({ page, pagesize, search, id, ordering }, thunkAPI) => {
        try {
            const response = await blosterService.getBlosterList(page, pagesize, search, id, ordering);
            return response.data;

        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);



export const fetchBlosterDropdown = createAsyncThunk(
    'bloster/fetchBlosterDropdown',
    async ({ page, pagesize, search, id, ordering }, thunkAPI) => {
        try {
            const response = await blosterService.getBlosterDropdown(page, pagesize, search, id, ordering);
            return response.data;

        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);
export const fetchArchiveBlosterList = createAsyncThunk(
    'bloster/fetchArchiveBlosterList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await blosterService.getArchiveBlosterList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data: { users, totalpage, etc. }}
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const fetchDieBolsterById = createAsyncThunk(
    'bloster/fetchDieBolsterById',
    async (Id, { rejectWithValue }) => {
        try {
            const response = await blosterService.getDieBolsterById(Id);

            return response.data; // Return the profile data

        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const createBloster = createAsyncThunk(
    'bloster/createBloster',
    async ({ values, bloster_image, autocard, pdf }, thunkAPI) => {
        try {
            const formPayload = new FormData();
            const textPayload = {
                bloster_no: values.bloster_no,
                press: values.press,
                bloster_image: values.bloster_image,
                autocard: values.autocard,
                pdf: values.pdf,

            };

            formPayload.append("form_data", JSON.stringify(textPayload));
            if (bloster_image) {
                formPayload.append("bloster_image", bloster_image);
            }
            if (autocard) {
                formPayload.append("autocard", autocard);
            }
            if (pdf) {
                formPayload.append("pdf", pdf);
            }
            const response = await blosterService.createBloster(formPayload);
            return response.data; // Assuming response contains the created category data
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const editBolster = createAsyncThunk(
    'bolster/editBolster',
    async ({ id, values, bloster_image, autocard, pdf }, thunkAPI) => {
        try {
            const validateFile = (file) => file instanceof File;
            const formPayload = new FormData();
            const textPayload = {
                bloster_no: values.bloster_no,
                press: values.press,

            };
            formPayload.append("form_data", JSON.stringify(textPayload)); // Convert text fields to JSON

            if (bloster_image && validateFile(bloster_image)) {
                formPayload.append("bloster_image", bloster_image);
            }
            if (autocard && validateFile(autocard)) {
                formPayload.append("autocard", autocard);
            }
            if (pdf && validateFile(pdf)) {
                formPayload.append("pdf", pdf);
            }
            const response = await blosterService.updateBloster(id, formPayload);
            return response.data;

        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);


export const deleteBloster = createAsyncThunk(
    'bloster/deleteBloster',
    async (id, thunkAPI) => {
        try {
            await blosterService.deleteBloster(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const deleteBolsterImage = createAsyncThunk(
    'bloster/deleteBlosterImage',
    async ({ id, ImageUrl }, thunkAPI) => {
        try {
            const formPayload = new FormData();
            formPayload.append('bloster_image', ImageUrl);

            const response = await blosterService.deleteImageBloster(id, formPayload);
            return response.data;

        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const deleteAutoCardImageBolster = createAsyncThunk(
    'bloster/deleteImageBolster',
    async ({ id, ImageUrl }, thunkAPI) => {
        try {
            const formPayload = new FormData();
            formPayload.append('autocard', ImageUrl);

            const response = await blosterService.deleteImageBloster(id, formPayload);
            return response.data;

        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const deleteImageDetailFile = createAsyncThunk(
    'bloster/deleteImageDetailFile',
    async ({ id, ImageUrl }, thunkAPI) => {
        try {
            const formPayload = new FormData();
            formPayload.append('autocard', ImageUrl);

            const response = await blosterService.deleteImageBloster(id, formPayload);
            return response.data;

        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const unArchiveBloster = createAsyncThunk(
    'bloster/unArchiveBloster',
    async (id, thunkAPI) => {
        try {
            await blosterService.unArchiveBloster(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);


const initialState = {
    data: [],
    list: [],
    loading: false,
    totalpage: 0,
    currentpage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
};

const blosterSlice = createSlice({
    name: 'bloster',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetBlosterList: (state) => {
            state.list = []; // This will clear the list
        },
        resetCurrentBlosterPage: (state) => {
            state.currentpage = 1;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBlosterList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchBlosterList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.totaldie = action.payload.total_die_count || 0;
                state.totaltool = action.payload.total_die_tool_count || 0;
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchBlosterList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });


        builder
            .addCase(fetchBlosterDropdown.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchBlosterDropdown.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchBlosterDropdown.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(fetchArchiveBlosterList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchiveBlosterList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchiveBlosterList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(createBloster.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createBloster.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createBloster.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(editBolster.pending, state => {
                state.status = 'loading';
            })
            .addCase(editBolster.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(editBolster.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(deleteBloster.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteBloster.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteBloster.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveBloster.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveBloster.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveBloster.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(fetchDieBolsterById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDieBolsterById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload; // Update the state with the fetched data
            })
            .addCase(fetchDieBolsterById.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'Failed to fetch Die Bolster details';
            });

    },
});

export const { resetBlosterList, resetCurrentBlosterPage, } = blosterSlice.actions;
const { reducer } = blosterSlice;
export default reducer;
